import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import {
	getProductCategory,
	updateProductCategory,
} from "../../../apis/productCategory";
import { toastify } from "../../../helperFunctions/toastify";
import { customStringSort } from "../../../helperFunctions/utils";
import DeleteModal from "../../SharedComponents/DeleteModal";
import FilterComponent from "../../SharedComponents/FilterComponent";

export default function ProductCategory() {
	const navigate = useNavigate();
	const [productCategory, setProductCategory] = useState([]);
	const [filteredData, setFilteredData] = useState([]);
	const [show, setShow] = useState(false);
	const [deleting, setDeleting] = useState("");

	const handleClose = () => {
		setShow(false);
		setDeleting("");
	};

	const getProductCategoriesList = async () => {
		const response = await getProductCategory();
		if (response.status !== "Fail") {
			setProductCategory(response.reverse());
		} else {
			if (response?.message === "No data Found") {
				setProductCategory([]);
			} else {
				toastify(response?.message, "error");
			}
		}
	};

	const removeCategory = async () => {
		setShow(false);
		let response = await updateProductCategory(deleting, {
			isDeleted: true,
		});
		if (response?.status !== "Fail") {
			getProductCategoriesList();
			toastify("Product Category deleted successfully!", "success");
		} else {
			toastify(response?.message, "error");
		}
	};

	const editCategory = (e) => {
		navigate("/add-product-category", {
			state: {
				productCategory: e,
			},
		});
	};

	const addProductCategory = () => {
		navigate("/add-product-category");
	};

	useEffect(() => {
		getProductCategoriesList();
	}, []);

	const columns = [
		{
			name: (
				<div className="d-flex align-items-center" id="ovly8">
					<span className="me-2">Name</span>
					{
						<FilterComponent
							type="search"
							array={productCategory}
							setArray={setFilteredData}
							value="Name"
						/>
					}
				</div>
			),
			selector: (row) => row.name,
			wrap: true,
			sortable: true,
			sortFunction: (a, b) => customStringSort(a, b, "name"),
		},
		{
			name: "Description",
			selector: (row) => row.description,
			wrap: true,
			sortable: true,
			sortFunction: (a, b) => customStringSort(a, b, "description"),
		},
		{
			name: "Action",
			selector: (row) => row.action,
		},
	];

	const data = (
		filteredData.length === 0 ? productCategory : filteredData
	)?.map((e, index) => {
		return {
			id: e._id,
			name: e.name,
			index: index,
			description: e.description,
			action: (
				<div className="d-flex">
					<div
						className="mx-3  cursor-pointer icon-width"
						onClick={() => {
							editCategory(e);
						}}
					>
						<i className="fa fa-pen"></i>
					</div>
					<div
						className="mx-3  cursor-pointer icon-width"
						onClick={() => {
							setDeleting(e._id);
							setShow(true);
						}}
					>
						<i className="fa fa-trash"></i>
					</div>
				</div>
			),
		};
	});

	const customStyles = {
		headCells: {
			style: {
				justifyContent: "center",
			},
		},
		cells: {
			style: {
				justifyContent: "center",
				textAlign: "center",
			},
		},
	};

	const conditionalRowStyles = [
		{
			when: (row) => row,
			style: {
				borderWidth: "0px",
			},
		},
		{
			when: (row) => row.index % 2 === 1,
			style: {
				borderWidth: "0px",
				backgroundColor: "#f8f8f8",
			},
		},
	];

	return (
		<>
			<div className="container p-0">
				<div className="mainHeading px-4">
					<h1>Product Category (Inventory)</h1>
					<Button className="addItem" onClick={addProductCategory}>
						+ Add New
					</Button>
				</div>

				<DeleteModal
					content="Confirm Product Category Deletion?"
					onYes={removeCategory}
					onNo={handleClose}
					show={show}
				/>

				<DataTable
					columns={columns}
					customStyles={customStyles}
					data={data || []}
					pagination
					conditionalRowStyles={conditionalRowStyles}
				/>
			</div>
		</>
	);
}
